import { useCallback, useEffect, useState } from "react";
import { getFoldersForAnalytics } from "../../../api";
import { AnalyticsFolderOption } from "../types";

interface UseFoldersForAnalytics {
    folders: AnalyticsFolderOption[];
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

export const useFoldersForAnalytics = (): UseFoldersForAnalytics => {
    const [folders, setFolders] = useState<AnalyticsFolderOption[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const load = useCallback(async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            setError("missing-token");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await getFoldersForAnalytics({ token });
            setFolders(res.folders || []);
        } catch (e: any) {
            setError(e?.message || "unknown-error");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { folders, loading, error, refetch: load };
};
